/* eslint-disable import/prefer-default-export */
/* eslint-disable arrow-body-style */
/* eslint-disable import/order */
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import ChatSlice from "./chat-message";
import { ThemeSlice } from "./dark-light-theme";
import authSlice from "./loginForm";
import TaskSlice from "./task";
import TaxSlice from "./tax";
import { leadSlice } from "./lead";
import { auctionApiSlice } from "./auctionApiSlice";
import { lotApiSlice } from "./lotApiSlice";
import { categoryApiSlice } from "./categoryApiSlice";
import { auctioneerApiSlice } from "./auctioneerApiSlice";
import { cashierApiSlice } from "./cashierApiSlice";
import { clearanceApiSlice } from "./clearanceApiSlice";
import { staffApiSlice } from "./staffApiSlice";
import auctionLotSlice from "./auctionLot";
import { orderApiSlice } from "./orderApiSlice";
import { registrationApplicationsApiSlice } from "./registrationApplicationsApiSlice";
import { invoiceApiSlice } from "./invoiceApiSlice";
import { supportApiSlice } from "./supportApiSlice";
import { faqApiSlice } from "./faqApiSlice";
import { faqCategoryApiSlice } from "./faqCategorySlice";
import { subscribeEmailApiSlice } from "./subscribeEmailApiSlice";
import { refundApiSlice } from "./refundApiSlice";
import { subCategoryApiSlice } from "./subCategoryApiSlice";
import notificationReducer from "./notificationSlice/notificationSlice";
import { bankApiSlice } from "./bankApiSlice";
import { sellerApiSlice } from "./sellerApiSlice";
import { buyerApiSlice } from "./buyerApiSlice";

// Define the root reducer
const rootReducer = combineReducers({
  auth: authSlice,
  chat: ChatSlice,
  themeDark: ThemeSlice.reducer,
  lead: leadSlice.reducer,
  task: TaskSlice,
  tax: TaxSlice,
  auctionLot: auctionLotSlice,
  notification: notificationReducer,
  [auctionApiSlice.reducerPath]: auctionApiSlice.reducer,
  [lotApiSlice.reducerPath]: lotApiSlice.reducer,
  [categoryApiSlice.reducerPath]: categoryApiSlice.reducer,
  [auctioneerApiSlice.reducerPath]: auctioneerApiSlice.reducer,
  [cashierApiSlice.reducerPath]: cashierApiSlice.reducer,
  [clearanceApiSlice.reducerPath]: clearanceApiSlice.reducer,
  [staffApiSlice.reducerPath]: staffApiSlice.reducer,
  [orderApiSlice.reducerPath]: orderApiSlice.reducer,
  [registrationApplicationsApiSlice.reducerPath]:
    registrationApplicationsApiSlice.reducer,
  [invoiceApiSlice.reducerPath]: invoiceApiSlice.reducer,
  [supportApiSlice.reducerPath]: supportApiSlice.reducer,
  [faqApiSlice.reducerPath]: faqApiSlice.reducer,
  [faqCategoryApiSlice.reducerPath]: faqCategoryApiSlice.reducer,
  [subscribeEmailApiSlice.reducerPath]: subscribeEmailApiSlice.reducer,
  [refundApiSlice.reducerPath]: refundApiSlice.reducer,
  [subCategoryApiSlice.reducerPath]: subCategoryApiSlice.reducer,
  [bankApiSlice.reducerPath]: bankApiSlice.reducer,
  [sellerApiSlice.reducerPath]: sellerApiSlice.reducer,
  [buyerApiSlice.reducerPath]: buyerApiSlice.reducer,
});

// Create the persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "lead", "themeDark"], // persist only 'auth' and 'themeDark'
};

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      auctionApiSlice.middleware,
      lotApiSlice.middleware,
      categoryApiSlice.middleware,
      auctioneerApiSlice.middleware,
      cashierApiSlice.middleware,
      clearanceApiSlice.middleware,
      staffApiSlice.middleware,
      orderApiSlice.middleware,
      registrationApplicationsApiSlice.middleware,
      invoiceApiSlice.middleware,
      supportApiSlice.middleware,
      faqApiSlice.middleware,
      faqCategoryApiSlice.middleware,
      subscribeEmailApiSlice.middleware,
      refundApiSlice.middleware,
      subCategoryApiSlice.middleware,
      bankApiSlice.middleware,
          sellerApiSlice.middleware,
          buyerApiSlice.middleware
    ),
});

persistStore(store);

export { store };
